import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

export const apartmentSellBuildingTypeOptions = [
  BuildingTypeOption.APARTMENT,
  BuildingTypeOption.ATTIC,
  BuildingTypeOption.BASEMENT,
  BuildingTypeOption.DUPLEX,
  BuildingTypeOption.ENTRESOL,
  BuildingTypeOption.GROUND_FLOOR,
  BuildingTypeOption.LOFT,
  BuildingTypeOption.PENTHOUSE,
  BuildingTypeOption.TERRACE,
  BuildingTypeOption.OTHER,
]
